import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

// params: { from, to, timeZone } - from / to as YYYY-MM-DD
export const dashboardInsightsAPI = async (params) => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}dashboard/insights`,
    params: params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default dashboardInsightsAPI;
